


document.addEventListener("DOMContentLoaded", function() {
    const loader = document.querySelector(".loader");
    const loaderTop = document.querySelector(".loader-top");
    const loaderBottom = document.querySelector(".loader-bottom");
    const loaderBar = document.querySelector(".loader-bar");
    const loaderNumbering = document.querySelector(".loader-numbering");
    let loadingProgress = 0;
    let isContentLoaded = false;
    let shouldUpdateWidth = true;

    function incrementLoader() {
        if (!shouldUpdateWidth) return;

        loadingProgress += 1;
        const progressPercentage = Math.min(loadingProgress, 100);
        loaderBar.style.width = `${progressPercentage}%`;
        loaderNumbering.textContent = `${progressPercentage}%`;

        if (loadingProgress >= 100 && isContentLoaded) {
            hideLoaderBarAndNumbering();
        }
    }

    function hideLoaderBarAndNumbering() {
        shouldUpdateWidth = false; // Stop updating width
        loaderBar.style.transition = "opacity 0.5s ease-out";
        loaderNumbering.style.transition = "opacity 0.5s ease-out";
        loaderNumbering.style.opacity = "0";
        
        setTimeout(() => {
            loaderBar.style.opacity = "0";
            setTimeout(() => {
                hideLoaderTopAndBottom();
            }, 500);
        }, 500);
    }

    function hideLoaderTopAndBottom() {
        loaderTop.classList.add("hide");
        loaderBottom.classList.add("hide");

        setTimeout(() => {
            loader.classList.add("hide");
            document.body.style.overflow = "auto"; // Enable scrolling
        }, 500);
    }

    // Prevent scrolling when the loader is displayed
    document.body.style.overflow = "hidden";

    // Simulate data loading progress (example)
    const loadingInterval = setInterval(() => {
        incrementLoader();
        if (loadingProgress >= 100) {
            clearInterval(loadingInterval);
            isContentLoaded = true;
        }
    }, 50);

    // Simulate page loading (example)
    window.addEventListener("load", () => {
        isContentLoaded = true;
        if (loadingProgress >= 100) {
            hideLoaderBarAndNumbering();
        }
    });
});



$("header .menu_icon_otr").click(function(){
  $(".overlay_main").addClass("overlay_open");
});
$(".overlay_main .close_icon_otr").click(function(){
  $(".overlay_main").removeClass("overlay_open");
});


/*========== Marquee on hover stop function code ==========*/


$(function() {
    var marquee = $('#text-marquee-effect');
    var marqueePaused = false;
  
    marquee.on('mouseenter', function() {
        marqueePaused = true;
        marquee[0].stop();
    });
  
    marquee.on('mouseleave', function() {
        marqueePaused = false;
        marquee[0].start();
    });
});


$(function() {
    var marquee = $('#text-marquee-effect2');
    var marqueePaused = false;
  
    marquee.on('mouseenter', function() {
        marqueePaused = true;
        marquee[0].stop();
    });
  
    marquee.on('mouseleave', function() {
        marqueePaused = false;
        marquee[0].start();
    });
});

/*========== Marquee on hover stop function code ==========*/


// Function to format market cap
function formatMarketCap(marketCap) {
    const units = ['k', 'M', 'B', 'T'];
    let unitIndex = 0;
    while (marketCap >= 1000 && unitIndex < units.length - 1) {
        marketCap /= 1000;
        unitIndex++;
    }
    return marketCap.toFixed(2) + units[unitIndex];
}

// Array of cryptocurrency symbols and names you want to display
const coinsLists = [
    { container: ".coins-list-1", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "ethereum", name: "Ethereum", rank: 2 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
        { symbol: "dogecoin", name: "Dogecoin", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "solana", name: "Solana", rank: 9 },
        { symbol: "tron", name: "TRON", rank: 10 },
        { symbol: "polkadot", name: "Polkadot", rank: 11 },
        { symbol: "polygon", name: "Polygon", rank: 12 },
    ] },
    { container: ".coins-list-2", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "ethereum", name: "Ethereum", rank: 2 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
        { symbol: "dogecoin", name: "Dogecoin", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "solana", name: "Solana", rank: 9 },
        { symbol: "tron", name: "TRON", rank: 10 },
        { symbol: "polkadot", name: "Polkadot", rank: 11 },
        { symbol: "polygon", name: "Polygon", rank: 12 },
    ] },
    { container: ".coins-list-3", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "ethereum", name: "Ethereum", rank: 2 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
        { symbol: "dogecoin", name: "Dogecoin", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "solana", name: "Solana", rank: 9 },
        { symbol: "tron", name: "TRON", rank: 10 },
        { symbol: "polkadot", name: "Polkadot", rank: 11 },
        { symbol: "polygon", name: "Polygon", rank: 12 },
    ] },
    { container: ".coins-list-4", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
        { symbol: "dogecoin", name: "Dogecoin", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
    ] },
    { container: ".coins-list-5", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "ethereum", name: "Ethereum", rank: 2 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
        { symbol: "dogecoin", name: "Dogecoin", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "solana", name: "Solana", rank: 9 },
        { symbol: "tron", name: "TRON", rank: 10 },
        { symbol: "polkadot", name: "Polkadot", rank: 11 },
        { symbol: "polygon", name: "Polygon", rank: 12 },
    ] },
    { container: ".coins-list-6", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "ethereum", name: "Ethereum", rank: 2 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
        { symbol: "dogecoin", name: "Dogecoin", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "solana", name: "Solana", rank: 9 },
        { symbol: "tron", name: "TRON", rank: 10 },
        { symbol: "polkadot", name: "Polkadot", rank: 11 },
        { symbol: "polygon", name: "Polygon", rank: 12 },
    ] },
    { container: ".coins-list-7", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "ethereum", name: "Ethereum", rank: 2 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
        { symbol: "dogecoin", name: "Dogecoin", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "solana", name: "Solana", rank: 9 },
        { symbol: "tron", name: "TRON", rank: 10 },
        { symbol: "polkadot", name: "Polkadot", rank: 11 },
        { symbol: "polygon", name: "Polygon", rank: 12 },
    ] },
    { container: ".coins-list-8", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "ethereum", name: "Ethereum", rank: 2 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
        { symbol: "dogecoin", name: "Dogecoin", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "solana", name: "Solana", rank: 9 },
        { symbol: "tron", name: "TRON", rank: 10 },
        { symbol: "polkadot", name: "Polkadot", rank: 11 },
        { symbol: "polygon", name: "Polygon", rank: 12 },
    ] },
    { container: ".coins-list-9", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "ethereum", name: "Ethereum", rank: 2 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
        { symbol: "dogecoin", name: "Dogecoin", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "solana", name: "Solana", rank: 9 },
        { symbol: "tron", name: "TRON", rank: 10 },
        { symbol: "polkadot", name: "Polkadot", rank: 11 },
        { symbol: "polygon", name: "Polygon", rank: 12 },
    ] },
    { container: ".coins-list-10", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "ethereum", name: "Ethereum", rank: 2 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
        { symbol: "dogecoin", name: "Dogecoin", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "solana", name: "Solana", rank: 9 },
        { symbol: "tron", name: "TRON", rank: 10 },
        { symbol: "polkadot", name: "Polkadot", rank: 11 },
        { symbol: "polygon", name: "Polygon", rank: 12 },
    ] },
    // Add more lists with their coins as needed
];

coinsLists.forEach((coinsList, index) => {
    coinsList.coins.forEach((coin, coinIndex) => {
        getCoinData(coin.symbol, coinsList.container, index, coinIndex);
    });
});

function getCoinData(coinSymbol, container, index, coinIndex) {
    fetch(`https://api.coincap.io/v2/assets/${coinSymbol}`)
        .then(response => response.json())
        .then(data => {
            const coinInfo = data.data;
            getCoinPriceHistory(coinSymbol, coinInfo, container, index, coinIndex);
        })
        .catch(error => {
            console.error("Failed to fetch coin data.", error);
        });
}

function getCoinPriceHistory(coinSymbol, coinInfo, container, index, coinIndex) {
    fetch(`https://api.coincap.io/v2/assets/${coinSymbol}/history?interval=d1`)
        .then(response => response.json())
        .then(data => {
            const priceData = data.data;
            displayCoinData(coinInfo, priceData, container, index, coinIndex);
        })
        .catch(error => {
            console.error("Failed to fetch price history data.", error);
        });
}

function displayCoinData(coinInfo, priceData, container, index, coinIndex) {
    const coinsList = document.querySelector(container);

    const coinCard = document.createElement("div");
    coinCard.classList.add("col-lg-4");

    const formattedCurrentPrice = parseFloat(coinInfo.priceUsd).toFixed(2);

    const changePercent = parseFloat(coinInfo.changePercent24Hr);
    const formattedPriceChange = isNaN(changePercent)
        ? "N/A" // Handle invalid or missing data
        : changePercent >= 0
            ? `+${changePercent.toFixed(2)}%`
            : `${changePercent.toFixed(2)}%`;

    const iconName = coinInfo.name.charAt(0).toLowerCase() + coinInfo.name.slice(1);
    const imagePath = `https://vistothemes.com/cryptocurrency/coins/${iconName}.png`;

    // Customize display based on coin list
    if (index === 0) {
        // Coin List 1: Display Everything
        coinCard.innerHTML = `
            <div class="marquee">
                <div class="coin-img-otr">
                    <img class="coin-img" class="${coinInfo.name}" src="${imagePath}" alt="${coinInfo.name}" />
                </div>
                <p class="coin-name">${coinInfo.name}</p>
                <p class="current-price">$${formattedCurrentPrice}</p>
                <p class="change-price">${formattedPriceChange}</p>
            </div>
        `;

        coinsList.appendChild(coinCard);

    }  else if (index === 1) {
        // Coin List 2: Display Everything Except Market Cap and Price Chart
        coinCard.innerHTML = `
            <div class="col-inr">
                <div class="card-head">
                    <div class="coin-basic-info">
                        <div class="coin-img-otr">
                            <img class="coin-img" src="${imagePath}" alt="${coinInfo.name}" />
                        </div>
                        <div class="coin-name-info">
                            <p class="coin-name">${coinInfo.name}</p>
                            <p class="coin-symbol">${coinInfo.symbol}</p>
                        </div>
                    </div>
                    <div class="price-change-otr">
                        <p class="price-change">${formattedPriceChange}</p>
                    </div>
                </div>
                <div class="current-price-otr">
                    <p class="current-price">$${formattedCurrentPrice}</p>
                    <p class="market-cap">Market Cap : $${formatMarketCap(parseFloat(coinInfo.marketCapUsd))}</p>
                </div>
                <div class="price-chart">
                    <canvas id="${coinInfo.id}-chart-${container}-${index}-${coinIndex}"></canvas>
                </div>
            </div>
        `;

        coinsList.appendChild(coinCard);

    } else if (index === 2) {
        // Coin List 3: Display Everything
        coinCard.innerHTML = `
            <div class="col-inr">
                <div class="coin-basic-info">
                    <div class="coin-img-otr">
                        <img class="coin-img" class="${coinInfo.name}" src="${imagePath}" alt="${coinInfo.name}" />
                        <p class="coin-name">${coinInfo.name}</p>
                    </div>
                    <div class="coin-name-info">
                        <p class="coin-symbol">${coinInfo.symbol}</p>
                    </div>
                </div>
                <div class="coin-name-info">
                <p class="current-price"> $${formattedCurrentPrice} </p>
                </div>
                <div class="price-chart">
                    <canvas id="${coinInfo.id}-chart-${container}-${index}-${coinIndex}"></canvas>
                </div>
                <div class="price-change-otr">
                    <p class="price-change">${formattedPriceChange}</p>
                    <p class="market-cap">Market Cap : $${formatMarketCap(parseFloat(coinInfo.marketCapUsd))}</p>
                </div>
            </div>
        `;

        coinsList.appendChild(coinCard);

    } else if (index === 3) {
        // Coin List 4: Display Everything
        coinCard.innerHTML = `
            <div class="marquee">
                <div class="flex-main">
                    <div class="coin-img-otr">
                        <img class="coin-img" class="${coinInfo.name}" src="${imagePath}" alt="${coinInfo.name}" />
                    </div>
                    <div class="coin-prices-main">
                        <p class="coin-name">${coinInfo.name} <span>(${coinInfo.symbol})</span></p>
                        <p class="current-price">$${formattedCurrentPrice}</p>
                    </div>
                </div>
                <p class="change-price">${formattedPriceChange}</p>
            </div>
        `;

        coinsList.appendChild(coinCard);

    } else if (index === 4) {
        // Coin List 5: Display Everything
        coinCard.innerHTML = `
            <div class="col-inr">
                <div class="coin-basic-info">
                    <div class="coin-img-otr">
                        <img class="coin-img" class="${coinInfo.name}" src="${imagePath}" alt="${coinInfo.name}" />
                        <p class="coin-name">${coinInfo.name}</p>
                    </div>
                    <div class="coin-name-info">
                        <p class="coin-symbol">${coinInfo.symbol}</p>
                    </div>
                </div>
                <div class="coin-name-info">
                <p class="current-price"> $${formattedCurrentPrice} </p>
                </div>
                <div class="price-chart">
                    <canvas id="${coinInfo.id}-chart-${container}-${index}-${coinIndex}"></canvas>
                </div>
                <div class="price-change-otr">
                    <p class="price-change">${formattedPriceChange}</p>
                    <p class="market-cap">Market Cap : $${formatMarketCap(parseFloat(coinInfo.marketCapUsd))}</p>
                </div>
            </div>
        `;

        coinsList.appendChild(coinCard);

    } else if (index === 5) {
        // Coin List 6: Display Everything
        coinCard.innerHTML = `
            <div class="marquee">
                <div class="coin-img-otr">
                    <img class="coin-img" class="${coinInfo.name}" src="${imagePath}" alt="${coinInfo.name}" />
                </div>
                <p class="coin-name">${coinInfo.name}</p>
                <p class="current-price">$${formattedCurrentPrice}</p>
                <p class="change-price">${formattedPriceChange}</p>
            </div>
        `;

        coinsList.appendChild(coinCard);

    } else if (index === 6) {
        // Coin List 7: Display Everything
        coinCard.innerHTML = `
            <div class="marquee">
                <div class="coin-img-otr">
                    <img class="coin-img" class="${coinInfo.name}" src="${imagePath}" alt="${coinInfo.name}" />
                </div>
                <p class="coin-name">${coinInfo.name}</p>
                <p class="current-price">$${formattedCurrentPrice}</p>
                <p class="change-price">${formattedPriceChange}</p>
            </div>
        `;

        coinsList.appendChild(coinCard);

    } else if (index === 7) {
        // Coin List 8: Display Everything
        coinCard.innerHTML = `
            <div class="marquee">
                <div class="coin-img-otr">
                    <img class="coin-img" class="${coinInfo.name}" src="${imagePath}" alt="${coinInfo.name}" />
                </div>
                <p class="coin-name">${coinInfo.name}</p>
                <p class="current-price">$${formattedCurrentPrice}</p>
                <p class="change-price">${formattedPriceChange}</p>
            </div>
        `;

        coinsList.appendChild(coinCard);

    } else if (index === 8) {
        // For Swiper Slides, only create swiper-slide div
        // Coin List 9: Display Everything
        const coinCardd = document.createElement("div");
        coinCardd.classList.add("swiper-slide");

        const formattedCurrentPrice = parseFloat(coinInfo.priceUsd).toFixed(2);

        const changePercent = parseFloat(coinInfo.changePercent24Hr);
        const formattedPriceChange = isNaN(changePercent)
            ? "N/A" // Handle invalid or missing data
            : changePercent >= 0
                ? `+${changePercent.toFixed(2)}%`
                : `${changePercent.toFixed(2)}%`;

        const iconName = coinInfo.name.charAt(0).toLowerCase() + coinInfo.name.slice(1);
        const imagePath = `https://vistothemes.com/cryptocurrency/coins/${iconName}.png`;

        coinCardd.innerHTML = `
            <div class="col-inr">
                <div class="card-head">
                    <div class="coin-basic-info">
                        <div class="coin-img-otr">
                            <img class="coin-img" src="${imagePath}" alt="${coinInfo.name}" />
                        </div>
                        <div class="coin-name-info">
                            <p class="coin-name">${coinInfo.name}</p>
                            <p class="coin-symbol">${coinInfo.symbol}</p>
                        </div>
                    </div>
                    <div class="price-change-otr">
                        <p class="price-change">${formattedPriceChange}</p>
                    </div>
                </div>
                <div class="current-price-otr">
                    <p class="current-price">$${formattedCurrentPrice}</p>
                    <p class="market-cap">Market Cap : $${formatMarketCap(parseFloat(coinInfo.marketCapUsd))}</p>
                </div>
                <div class="price-chart">
                    <canvas id="${coinInfo.id}-chart-${container}-${index}-${coinIndex}"></canvas>
                </div>
            </div>
        `;

        coinsList.appendChild(coinCardd);

    } else if (index === 9) {
        // For Swiper Slides, only create swiper-slide div
        // Coin List 9: Display Everything
        const coinCardd = document.createElement("div");
        coinCardd.classList.add("swiper-slide");

        const formattedCurrentPrice = parseFloat(coinInfo.priceUsd).toFixed(2);

        const changePercent = parseFloat(coinInfo.changePercent24Hr);
        const formattedPriceChange = isNaN(changePercent)
            ? "N/A" // Handle invalid or missing data
            : changePercent >= 0
                ? `+${changePercent.toFixed(2)}%`
                : `${changePercent.toFixed(2)}%`;

        const iconName = coinInfo.name.charAt(0).toLowerCase() + coinInfo.name.slice(1);
        const imagePath = `https://vistothemes.com/cryptocurrency/coins/${iconName}.png`;

        coinCardd.innerHTML = `
            <div class="col-inr">
                <div class="card-head">
                    <div class="coin-basic-info">
                        <div class="coin-img-otr">
                            <img class="coin-img" src="${imagePath}" alt="${coinInfo.name}" />
                        </div>
                        <div class="coin-name-info">
                            <p class="coin-name">${coinInfo.name}</p>
                            <p class="coin-symbol">${coinInfo.symbol}</p>
                        </div>
                    </div>
                    <div class="price-change-otr">
                        <p class="price-change">${formattedPriceChange}</p>
                    </div>
                </div>
                <div class="current-price-otr">
                    <p class="current-price">$${formattedCurrentPrice}</p>
                    <p class="market-cap">Market Cap : $${formatMarketCap(parseFloat(coinInfo.marketCapUsd))}</p>
                </div>
                <div class="price-chart">
                    <canvas id="${coinInfo.id}-chart-${container}-${index}-${coinIndex}"></canvas>
                </div>
            </div>
        `;

        coinsList.appendChild(coinCardd);

    }

    

    // Create the price chart using Chart.js library
    if (index === 1 || index === 2 || index === 4 || index === 5 || index === 8 || index === 9) {
        // Coin List 1 and Coin List 4: Display Price Chart
        const ctx = document.getElementById(`${coinInfo.id}-chart-${container}-${index}-${coinIndex}`).getContext("2d");
        const coinLabels = priceData.map(item => moment(item.time).format('MM/DD'));
        const coinPrices = priceData.map(item => item.priceUsd);

        new Chart(ctx, {
            type: 'line',
            data: {
                labels: coinLabels,
                datasets: [{
                    label: 'Price (USD)',
                    data: coinPrices,
                    backgroundColor: (context) => {
                        const bgColor = [
                            'rgba(1, 82, 255, 0.2)',
                            'rgba(128, 169, 255, 0)',
                            'rgba(230, 109, 1, 0)',
                            
                        ];
                        if(!context.chart.chartArea) {
                            return;
                        }
                        console.log(context.chart.chartArea)
                        const { ctx, data, chartArea: {top, bottom} } = context.chart;
                        const gradientBg = ctx.createLinearGradient(0, top, 0, bottom);
                        gradientBg.addColorStop(0, bgColor[0])
                        gradientBg.addColorStop(1, bgColor[1])
                        gradientBg.addColorStop (1, bgColor [2])
                        return gradientBg;
                    },
                    borderColor: [
                        'rgba(1, 82, 255, 1)',
                    ],
                    pointBackgroundColor: [
                        'rgba(128, 169, 255, 1)',
                    ],
                    borderWidth: 2,
                    tension: 2,
                    lineTension: 0.25,
                    pointRadius: 0,
                    pointHoverRadius: 0,
                    fill: true
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                },
                scales: {
                    x: {
                        ticks: {
                            display: false,
                        },
                        grid: {
                            display: false,
                            drawTicks: false,
                        }
                    },
                    y: {
                        ticks: {
                            display: false,
                        },
                        grid: {
                            display: false,
                            drawTicks: false,
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                    }
                },
            }
        });
    }
}






document.addEventListener("DOMContentLoaded", function () {
    const slider1 = new Swiper("#slider1", {
        slidesPerView: "auto",
        spaceBetween: 120,
        centeredSlides: true,
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    const slider2 = new Swiper("#slider2", {
        slidesPerView: 3,
        spaceBetween: 24,
        centeredSlides: true,
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    const slider3 = new Swiper("#slider3-CTA", {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 120,
        grabCursor: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
    });
});